import React from "react";
import { Card } from "react-bootstrap";
import { ProgressBar } from "react-bootstrap";
import "../../assets/css/icons.css";
import CustomDropdown from "./CustomDropdown";
import { withNamespaces } from "react-i18next";

const Projetos = ({ apagarWidget, ...props }) => {
  const { t } = props;

  return (
    <div className="main-card-v2">
      <Card bsPrefix="card-flat">
        <Card.Header className="justify-content-between">
          <h6>
            <i className="icon-bell mr-2" />
            {t("Projetos.title")}
          </h6>
          <CustomDropdown apagarWidget={apagarWidget} />
        </Card.Header>
        <Card.Body>
          <span>
            {" "}
            RegTech & Compliance <span className="project-ready">23%</span>
          </span>
          <ProgressBar now={23} />
          <span>
            {" "}
            Finance & BI <span className="project-ready">80%</span>
          </span>
          <ProgressBar now={80} />
          <span>
            {" "}
            HR & Talent <span className="project-ready">67%</span>
          </span>
          <ProgressBar now={67} />
          <span>
            {" "}
            BPM <span className="project-ready">75%</span>
          </span>
          <ProgressBar now={75} />
          <span>
            {" "}
            Marketing <span className="project-ready">Complete!</span>
          </span>
          <ProgressBar now={100} />
        </Card.Body>
      </Card>
    </div>
  );
};
export default withNamespaces()(Projetos);
